<script setup lang="ts">
import { BAlert } from 'bootstrap-vue-next';
defineProps<{ error?: string }>();
</script>
<template>
  <BAlert :model-value="!!error" variant="danger">{{ error }}</BAlert>
</template>
